import _defaults from 'lodash/defaults'

export default {
  getters: {
    Reservation: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].reservation
          : {},
        {
          'section-heading': 'Reservation Steps',
          'section-subheading':
            '<p><strong>To confirm your reservation, please follow the three steps below:</strong></p>',

          'step-terms-enabled': true,
          'step-terms-heading': 'Review Your Trip & Terms and Conditions',
          'step-terms-content': '',

          'step-payment-enabled': true,
          'step-payment-heading': 'Pay your deposit',
          'step-payment-content':
            '<p><span style="color:#1d1c1d">Details for your trip deposit and payment options can be found by clicking &quot;Make Payment&quot; below.</span></p>',

          'step-pifs-enabled': true,
          'step-pifs-heading': 'Fill out our Personal Information Forms',
          'step-pifs-content': ''
        }
      )
    }
  }
}
